<style>
.point_down {
  width: 100% !important;
  top: 0px;
  position: fixed;
  z-index: 9999;
}
</style>
<template>
  <div>
    <headerNav></headerNav>
    <img
      src="./../assets/images/point_down.png"
      v-show="showImg"
      class="point_down"
      @click="imgBtn"
    >
    <div class="center_box">
      <div class="center_title">编辑·打印·更高效</div>
      <div class="center_titleTwo">丰富的内容编辑 手机可无线蓝牙打印</div>
      <img src="./../assets/images/back.png" alt @click="test()">
    </div>
    <div class="download_box">
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/android.png">
        </div>
        <div class="m_floatL download_text">
          <div>Dlabel安卓端下载</div>
          <div>2020-10-20</div>
          <div>用于蓝牙版标签打印</div>
        </div>
        <div class="m_floatR download_down" @click="btnApk">
          <a>下载</a>
        </div>
      </div>
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/iphone.png">
        </div>
        <div class="m_floatL download_text">
          <div>Dlabel苹果端下载</div>
          <div>2020-10-20</div>
          <div>蓝牙版标签打印,需ios10.3以上系统</div>
        </div>
        <div class="m_floatR download_down">
          <a href="https://itunes.apple.com/cn/app/id1397719437?mt=8">下载</a>
        </div>
      </div>

      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/pc.png">
        </div>
        <div class="m_floatL download_text">
          <div>电脑驱动和软件</div>
          <div>30.2MB 2020-10-20</div>
          <div>电脑端下载网址:www.dlabel.cn</div>
        </div>
        <div class="m_floatR download_down">
          <a href="http://www.dlabel.cn/">查看</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from './header'
import axios from 'axios'
export default {
  components: {
    headerNav: header
  },
  data () {
    return {
      showImg: false,
      date: '',
      apk: 'https://fileadapp.ctaiot.com/dlabel_version/pc/website/Dlabel%E4%BA%91%E6%A0%87%E7%AD%BE.apk',
      textArr: [
        {
          // title:'Dlabel安卓端下载',
          // url:'http://39.108.49.16/media/app/app/Dlabel_112_1.apk',
          // size:'6.5MB'
        }
      ]
    }
  },
  created () {
    // axios.get("http://39.108.49.16/api/editor/version/").then(res => {

    //   // this.date = res.data[0].add_time.split("T")[0];
    // });
  },
  methods: {
    test () {
      location.href = 'https://dlabelh5.mydlabel.com/index.html'
    },
    imgBtn () {
      this.showImg = !this.showImg
    },
    isWeiXin () {
      // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    btnApk () {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
      if (isAndroid) {
        // 这个是安卓操作系统
        if (this.isWeiXin()) {
          this.showImg = true
        } else {
          location.href = this.apk
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/software.vue